import { FC } from 'react';

import { UIHeading3, UIText3 } from '@cian/ui-kit';

import styles from './Slide.css';

/**
 * @description Пропсы слайда.
 * @param imageUrl - URL изображения.
 * @param title - Заголовок слайда.
 * @param description - Описание слайда.
 * @example
 * <Slide imageUrl="https://example.com/image.jpg" title="Заголовок" description="Описание" />
 */
type SlideProps = {
  /**
   * @description URL изображения.
   */
  imageUrl: string;
  /**
   * @description Заголовок слайда.
   */
  title: string;
  /**
   * @description Описание слайда.
   */
  description: string;
};

/**
 * @description Слайд.
 * @param imageUrl - URL изображения.
 * @param title - Заголовок слайда.
 * @param description - Описание слайда.
 */
export const Slide: FC<SlideProps> = ({ imageUrl, title, description }) => {
  return (
    <div data-testid="slider-block-type-one-slide" className={styles['slide']}>
      <div className={styles['slide-content']}>
        <UIHeading3 data-testid="slider-block-type-one-slide-title">{title}</UIHeading3>
        <UIText3 data-testid="slider-block-type-one-slide-description">{description}</UIText3>
      </div>
      <img data-testid="slider-block-type-one-slide-image" className={styles['image']} src={imageUrl} />
    </div>
  );
};
